// Central place to manage social urls used across the site
const socialLinks = {
            facebook: 'https://www.facebook.com/people/100Eyes-technologies-LLP/61581622665978',
            twitter: 'https://x.com/100eyestech',
            linkedin: 'https://www.linkedin.com/company/100eyes-technologies',
            instagram: 'https://www.instagram.com/100eyestechonolgies/',
            youtube: 'https://www.youtube.com/@100eyestechnologies',
}

export default socialLinks
